import { Component, Shark } from "shark-mvc";
import moment from "moment";

import templateContent from "./active-work-session-display.html";
import "./style.css";
import notificationManager from "../../managers/notificationManager";
import workSessionManager from "../../managers/workSessionManager";

class ActiveWorkSessionDisplayComponent extends Component {
	constructor () {
		super("activeWorkSessionDisplayComponent");

		this.addTemplate("", templateContent);
	}

	afterRender () {
		const { runningWorkSession } = Shark.get();

		if (runningWorkSession && this.elapseTimerId === -1) {
			// console.log({runningWorkSession}); //alice

			// const descriptionBox = document.querySelector("#descriptionBox");
			
			// if (descriptionBox) {
			// 	// descriptionBox.focus();
			// 	// Utils.moveCaretToEnd(descriptionBox);
			// }
			
			activeWorkSessionDisplayComponent.elapseTimerStart();
		}
	}

	afterLoad () {
		this.checkRunningWorkSessionBodyClass();
	}
	
	beforeLoad () {
		const { runningWorkSession } = Shark.get();
		
		if (runningWorkSession) {
			runningWorkSession.off("descriptionChanged");
			runningWorkSession.on("descriptionChanged", function () {
				activeWorkSessionDisplayComponent.startSaveDescriptionTimer();
			});
		}
	}
	
	checkRunningWorkSessionBodyClass () {
		const { runningWorkSession } = Shark.get();
	
		if (runningWorkSession) {
			document.body.classList.add("isRunningWorkSession");
		}
		else {
			document.body.classList.remove("isRunningWorkSession");
		}
	}

	collapseRunningWorkSessionDisplayBtn_clickHandler () {
		const collapsed = !this.$store.collapsed;

		this.set({
			collapsed,
			collapsedCSSClass: collapsed ? "collapsed" : "",
		});

		localStorage.activeWorkSessionDisplayComponent_collapsed = collapsed;
		// Shark.render();
		activeWorkSessionDisplayComponent.elapseTimer_setTime();
	}

	descriptionBox_focusoutHandler () {
		const { runningWorkSession } = Shark.get();

		if (runningWorkSession.isDirty(["description", "extraData.urgent"])) {
			this.startSaveDescriptionTimer();
		}
	}

	descriptionBox_keyupHandler (event) {
		if (event.keyCode === 13 && event.ctrlKey) {
			this.stopRunningWorkSession();
		}
	}

	descriptionSaved () {
		clearTimeout(this.wsDescriptionLastUpdateTimerId);

		this.set({
			autoSavePending: false,
			__saveChangesDone: true,
			__saveChangesPending: false
		});
		Shark.render();
		
		setTimeout(() => {
			this.set({
				__saveChangesDone: false,
				__saveChangesPending: false
			});
			Shark.render();
		}, 3100);
	}

	elapseTimer_setTime () {
		const { runningWorkSession } = Shark.get();

		if (runningWorkSession) {
			runningWorkSession.updateElapsedTime();
			document.title = runningWorkSession.elapsedTime + " | TimeCorder (" + runningWorkSession.__projectName + " - " + runningWorkSession.__taskName + ")";
			// Shark.render();
		}
		else {
			clearInterval(this.elapseTimerId);
		}
	}

	elapseTimerStart () {
		if (this.elapseTimerId === -1) {
			activeWorkSessionDisplayComponent.elapseTimer_setTime();
			this.elapseTimerId = setInterval(activeWorkSessionDisplayComponent.elapseTimer_setTime, 1000);
		}
	}

	init () {
		this.elapseTimerId = -1;

		const collapsed = localStorage.activeWorkSessionDisplayComponent_collapsed == null ? false : localStorage.activeWorkSessionDisplayComponent_collapsed === "true";

		this.set({
			autoSavePending: false,
			collapsed,
			collapsedCSSClass: collapsed ? "collapsed" : "",
			__isEditingStartTime: false,
		});
	}

	saveRunningWorkSessionStartTimeBtn_clickHandler () {
		this.startSaveDescriptionTimer();

		const { runningWorkSession } = Shark.get();
		if (runningWorkSession) {
			workSessionManager.saveStartTime(runningWorkSession)
			.then( () => {
				this.$store.__isEditingStartTime = false;
				Shark.render();
			});
		}
	}

	startSaveDescriptionTimer () {
		if (this.wsDescriptionLastUpdateTimerId) {
			clearTimeout(this.wsDescriptionLastUpdateTimerId);
		}

		this.set({
			autoSavePending: true,
		});

		this.wsDescriptionLastUpdateTimerId = setTimeout(() => {
			const autoSaveTimeOutBar = document.querySelector("#autoSaveTimeOutBar");
			if (autoSaveTimeOutBar) {
				autoSaveTimeOutBar.classList.remove("running");
				autoSaveTimeOutBar.style.display = "";
			}
	
			this.set({
				__saveChangesDone: false,
				__saveChangesPending: true,
			});
			workSessionManager.saveDescription(Shark.get("runningWorkSession"))
			.then(() => {
				this.descriptionSaved();
			});
		}, 3000);

		const autoSaveTimeOutBar = document.querySelector("#autoSaveTimeOutBar");
		if (autoSaveTimeOutBar) {
			autoSaveTimeOutBar.classList.remove("running");
			autoSaveTimeOutBar.style.display = "block";
			setTimeout(() => {
				autoSaveTimeOutBar.classList.add("running");
			}, 100);
		}
	}

	startTime_clickHandler (event) {
		if (event.target.nodeName !== "INPUT" && event.target.id !== "saveRunningWorkSessionStartTimeBtn") {
			if (this.$store.__isEditingStartTime) {
				const { runningWorkSession } = Shark.get();
				// console.log(runningWorkSession);
				runningWorkSession.restore();
			}
			this.$store.__isEditingStartTime = !this.$store.__isEditingStartTime;
			Shark.render();
		}
	}

	stopRunningWorkSession () {
		clearTimeout(this.elapseTimerId);
		clearTimeout(this.wsDescriptionLastUpdateTimerId);
		this.elapseTimerId = -1;
		this.wsDescriptionLastUpdateTimerId = -1;

		const { runningWorkSession } = Shark.get();
		// Dovrebbe essere un set()
		runningWorkSession.endDate = moment();

		workSessionManager.stop(runningWorkSession)
		.then(stopResponse => {
			if (stopResponse.status === "ok") {
				Shark.set({
					runningWorkSession: null,
					__htmlTitle: "TimeCorder",
				});
				// Questo dovrebbe farlo al render, ma per ora lo fa solo all'openPage. (parlo del cambio di titolo in base a "__htmlTitle")
				document.title = "TimeCorder";
				workSessionManager.emit("openWSChecked");
				Shark.render();
				notificationManager.startShouldBeWorkingNotifications();
			}
			// else {
			// }
		});
	}

	stopSessionBtn_clickHandler () {
		this.stopRunningWorkSession();
		this.checkRunningWorkSessionBodyClass();
	}

	workSessionManager_errorHandler () {
		clearTimeout(this.wsDescriptionLastUpdateTimerId);

		const descriptionBoxStatus = document.querySelector("#descriptionBoxStatus");

		if (descriptionBoxStatus) {
			descriptionBoxStatus.className = "";
			descriptionBoxStatus.classList.add("error");
		}
	}
}

const activeWorkSessionDisplayComponent = new ActiveWorkSessionDisplayComponent();

Shark.registerComponent(activeWorkSessionDisplayComponent);

export default activeWorkSessionDisplayComponent;